jQuery(function ($) {
    let ajax_url = ajax.ajax_url; // Ajax URL

    let station_list = $('#user-stations').find('.stations-list');
    let message = '<p class="pre-lookup-message">Enter your postal code to view your local Key Life stations</p>';
    let locate_btn = null;

    let lat, lng;
    let api_key = 'AIzaSyDZcsgUUV_piuI31dK-X5DKVEn1xUNrIMs' +
        '';
    let base_url = 'https://maps.googleapis.com/maps/api/geocode/json';

    let use_geolocation = false;

    // Check if the users browser supports geolocation.
    if ("geolocation" in navigator) {
        //console.log('Geolocation will work');
        use_geolocation = true;
        message = '<p class="pre-lookup-message"><a href="#" class="geolocate button">View Local Stations</a><br>We will use your device\'s location to get the stations nearest you.</p>';
    }

    // Check for the cookie "station_zip" if it's there, then use that value to just perform the lookup when the page is loaded.
    let cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)station_zip\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    if (cookieValue !== false && cookieValue !== "") {
        station_lookup(cookieValue);
    } else {
        // Fill in the station_list section with a message for users to get their local stations.
        station_list.html(message);
    }


    /**
     * Station Lookup
     *
     * Requests the stations nearest the local zip.
     *
     * @param zip
     */
    function station_lookup(zip) {
        document.cookie = "station_zip=" + zip;

        $('.station-finder-zip').attr('value', zip);

        let data = {
            'action': 'station_lookup',
            'zip': zip
        };


        let query_string = $.param(data);

        let message = '<span class="lookup-message">Looking up stations near ' + zip + '</span>';

        station_list.html(message);

        // Use Fetch for the API call
        fetch(ajax_url, {
            method: 'POST',
            credentials: "same-origin", // include, same-origin, *omit
            headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}),
            body: query_string
        }).then(function (response) {
            //console.log('Fetch succeeded', response);
            return response.json();
        }).then(function (r) {
            //console.log('Contents');
            station_list.html(r.response);
            //console.log(r);
        }).catch(function (response) {
            console.log('Fetch Failed', response);
        });
    }

    function getLocation() {
        let message = '<span class="lookup-message">Getting your location</span>';

        station_list.html(message);

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(showPosition);
        } else {
            //x.innerHTML = "Geolocation is not supported by this browser.";
        }
    }

    function showPosition(position) {
        lat = position.coords.latitude;
        lng = position.coords.longitude;

        let endpoint = base_url + '?latlng=' + lat + ',' + lng + '&key=' + api_key + '&result_type=postal_code';

        fetch(endpoint).then(function (response) {
            //console.log('success');
            return response.json();
        }).then(function (json) {
            //console.log('Return');
            //console.log(json);
            let response = json['results'];
            let addresses = response[0].address_components;
            //console.log(response);
            //console.log(addresses.length);
            let postal = addresses[0].short_name;
            $('.station-finder-zip').attr('value', postal);

            station_lookup(postal);

        }).catch(function (response) {
            console.log('failed', response);
        });
    }

    /**
     * DOM Functions
     */

    /**
     * When enters in their own zipcode, get the zip they added and lookup the zip.
     */
    $('a.change-zip').on('click', function (e) {
        e.preventDefault();

        //console.log('Clicked the change zip button');

        let new_zip = $('.station-finder-zip').val();
        //console.log(new_zip);

        station_lookup(new_zip);
    });

    if (use_geolocation === true) {
        locate_btn = $('a.geolocate');

        locate_btn.on('click', function (e) {
            e.preventDefault();

            let message = '<span class="lookup-message">Getting your location</span>';

            station_list.html(message);

            getLocation();
        });
    }

});